import React from 'react';
import { X, Search, Calendar, Languages, Info } from 'lucide-react';
import Pennant from '../common/Pennant';
import { NAV_ITEMS } from '../../constants';
import { useSiteSettings } from '../../hooks/useSiteSettings';

function MobileDrawer({ isOpen, activeCat, onNavClick, onClose, onAdminClick }) {
  const settings = useSiteSettings();
  return (
    <div className={`fixed inset-0 z-[60] ${isOpen ? '' : 'pointer-events-none'}`}>
      <div
        className={`absolute inset-0 bg-black/50 transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0'}`}
        onClick={onClose}
      />
      <div
        className={`absolute top-0 right-0 bottom-0 w-[82%] max-w-[320px] bg-white flex flex-col p-5 transition-transform duration-300 ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex items-center justify-between mb-4">
          <span className="font-display text-[17px] font-bold flex items-center gap-2 min-w-0">
            {settings.header_logo ? (
              <img src={settings.header_logo} alt="Kalo Jhola" className="h-12 w-auto object-contain" />
            ) : (
              <>
                <Pennant size={16} /> KALO<em className="not-italic text-crimson">NEWS</em>
              </>
            )}
          </span>
          <button className="inline-flex items-center justify-center w-9 h-9 rounded-[10px] hover:bg-paper-soft flex-shrink-0" onClick={onClose} aria-label="Close menu">
            <X size={22} />
          </button>
        </div>

        <div className="flex items-center gap-2 bg-paper-soft border border-line rounded-full px-3.5 py-2.5 text-muted mb-4">
          <Search size={16} />
          <input
            type="text"
            placeholder="समाचार खोज्नुहोस्..."
            className="bg-transparent outline-none w-full text-sm"
            onKeyDown={(e) => {
              if (e.key === 'Enter' && e.target.value.trim()) {
                onNavClick('search', e.target.value.trim());
                onClose();
              }
            }}
          />
        </div>

        <div className="flex flex-col gap-0.5 overflow-y-auto">
          {NAV_ITEMS.map((c) => (
            <button
              key={c.id}
              className={`flex items-center gap-2.5 px-2.5 py-3 text-[14.5px] font-semibold rounded-[10px] text-left ${
                activeCat === c.id ? 'text-crimson bg-paper-soft' : 'text-ink-soft'
              }`}
              onClick={() => {
                onNavClick(c.id);
                onClose();
              }}
            >
              {c.id === 'calendar' ? (
                <Calendar size={16} />
              ) : c.id === 'unicode' ? (
                <Languages size={16} />
              ) : null}
              {c.label}
            </button>
          ))}
          <button
            className="flex items-center gap-2.5 px-2.5 py-3 text-[14.5px] font-semibold text-ink-soft rounded-[10px] text-left"
            onClick={() => {
              onNavClick('about');
              onClose();
            }}
          >
            <Info size={16} /> हाम्रोबारे
          </button>
        </div>
      </div>
    </div>
  );
}

export default MobileDrawer;
